import AccordianSlide from '../AccordianSlide'

export default function OurDAOSlide (props) {
  return (
    <AccordianSlide
      title='We are a DAO'
      stageName='Learning about Aragon'
      description='A DAO is a type of organization that is collectively owned and managed by its members. Members often hold a blockchain token associated with the DAO and use it to vote on decisions within the organization.'
      accordianData={[
        {
          title: 'Structure',
          body:
            'We do not have a CEO or Board of Directors. Our community is made up of different Guilds and Sub-DAOs. These Guilds are led by a loosely defined set of Core Contributors. However, every Contributors voice holds the same weight in decisions that are made through our voting process.'
        },
        {
          title: 'Decision Making',
          body:
            'We use an advice process for our decisions within the DAO. This process consists of bringing issues to the community and using the collective intelligence of the community to find a solution. Once agreed on, this will either go up for a vote or be put directly into action depending on the situation.'
        },
        {
          title: 'Compensation',
          body:
            'We currently operate on a bounty system for compensation. There are bounties that have been defined by the needs of the DAO. Then our contributors complete these bounties and are compensated with USDC and our Native ANT Token. You can find this Bounty Board <a class="link" href="https://www.notion.so/7dae5416065946418657264c7e6679ff?v=a92b0297505a45d588239a963799b0a6" target="_blank">here</a>.'
        }
      ]}
      {...props}
    />
  )
}
